import { UseFormRegister } from 'react-hook-form';
import { ConcentrationFormData } from 'interfaces/concentration';
import { FC } from 'react';

import { useTranslation } from 'react-i18next';
import RadioInput from 'components/UI/RadioInput/RadioInput';

/**
 * @description Props for the InfuseUntilEmpty component
 * @typedef {Object} InfuseUntilEmptyProps
 * @property {boolean} canManage - Whether the user has permission to manage this setting
 * @property {UseFormRegister<ConcentrationFormData>} register - React Hook Form register function
 */
type InfuseUntilEmptyProps = {
  canManage: boolean;
  register: UseFormRegister<ConcentrationFormData>;
};

/**
 * @description Component that renders radio buttons for the "Infuse Until Empty" setting.
 *
 * @SADtrace SAD-003-4.1, SAD-003-4.2, SAD-003-4.3
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @param {InfuseUntilEmptyProps} props - Component props
 *
 * @returns {JSX.Element} Rendered component
 */
const InfuseUntilEmpty: FC<InfuseUntilEmptyProps> = ({
  canManage,
  register,
}) => {
  const { t } = useTranslation();

  return (
    <div className="customRow pt-2">
      <div className="device-concentration-primary-secondary2--width">
        {t('device.infuse_until_empty')}
      </div>
      <div className="customRow ps-0  align-basic-radios">
        <RadioInput
          {...register('infuse_until_empty')}
          value={'OFF'}
          id="infuse_until_empty__off"
          disabled={!canManage}
          title={t('device.infuse_until_empty__off')}
          data-testid="infuse_until_empty"
        />
        <RadioInput
          {...register('infuse_until_empty')}
          value={'ON'}
          id="infuse_until_empty__on"
          disabled={!canManage}
          title={t('device.infuse_until_empty__on')}
          data-testid="infuse_until_empty"
        />
      </div>
    </div>
  );
};

export default InfuseUntilEmpty;
